/* no-instances.tsx generated by @compiled/babel-plugin v0.36.1 */
import "./no-instances.compiled.css";
import * as React from 'react';
import { ax, ix } from "@compiled/react/runtime";
import { useIntl } from 'react-intl-next';
import { Flex, Inline } from '@atlaskit/primitives/compiled';
import { NoInstancesSvg } from './no-instances-svg';
var styles = {
  titleStyles: "_11c8nbxd _19pkpxbi",
  descriptionStyles: "_19pku2gc",
  containerStyles: "_19pkxncg"
};
export var NoInstancesView = function NoInstancesView(_ref) {
  var title = _ref.title,
    description = _ref.description,
    testId = _ref.testId;
  var _useIntl = useIntl(),
    formatMessage = _useIntl.formatMessage;
  return /*#__PURE__*/React.createElement(Flex, {
    testId: testId,
    direction: "column",
    alignItems: "center",
    xcss: styles.containerStyles
  }, /*#__PURE__*/React.createElement(NoInstancesSvg, null), /*#__PURE__*/React.createElement(Inline, {
    as: "span",
    xcss: styles.titleStyles
  }, formatMessage(title)), /*#__PURE__*/React.createElement(Inline, {
    as: "span",
    xcss: styles.descriptionStyles
  }, formatMessage(description)));
};